export enum ObcCommandStatus {
	InCommand = 'in-command',
	NoCommand = 'no-command',
	PartialCommand = 'partial-command',
	SharedCommand = 'shared-command',
	CommandAvailable = 'command-available',
	Blocked = 'blocked',
}

export interface IObcAngleAdvice {
	minAngle: number;
	maxAngle: number;
	type: string;
	hinted: boolean;
}
